import { GraphQlClient, Lodash, Moment } from '@intelipost-js/secure-providers';
import { ScToast } from '@intelipost-js/secure-components';

export default {
  getOrdersToChangeStatus({ commit }, params = {}) {
    const { filters = {} } = params;
    const { search_by, search_values } = filters;
    commit('setFilters', Lodash.cloneDeep(filters));
    commit('toggleLoading', true);
    commit('setOrdersSelected', []);

    return GraphQlClient.query(`
    query (
      $search_by: String!,
      $search_values: [String]!
    ) {
      getOrdersToChangeStatus(
        search_by: $search_by,
        search_values: $search_values
      ) {
          order {
            state,
            order_number,
            end_customer {
              full_name,
            }
            logistic_provider {
              performance,
              delivery_method {
                name,
              }
            }
          }
          tracking_status {
            tracking {
              estimated_delivery_date
            }
          }
        }
      }`,
      {
        search_by,
        search_values,
      })
    .then((res) => {
      const { data = {} } = res || {};
      const { getOrdersToChangeStatus = [] } = data;
      commit('toggleLoading', false);
      commit('setOrdersToChangeStatus', getOrdersToChangeStatus);
      return Promise.resolve(res);
    })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  changeStatus({ commit, state, dispatch }, form) {
    const {
      date,
      time,
      status,
    } = form || {};

    const {
      ordersSelected,
      filters,
    } = state || {};

    commit('toggleLoading', true);

    const fullDate = `${Moment(date).format('YYYY-MM-DD')} ${Moment(time).format('HH:mm')}`;
    const params = {
      search_by: 'order_number',
      search_values: ordersSelected,
      status,
      date: Moment(fullDate).toISOString(),
    };

    return GraphQlClient.mutation(`
      mutation (
        $status: String!,
        $search_by: String!,
        $search_values: [String]!,
        $date: String!,
      ) {
        changeStatusWithDateTime(
          status: $status,
          search_by: $search_by
          search_values: $search_values
          date: $date
        ) {
            order {
              state
            }
          }
        }
      `, params)
      .then(() => {
        ScToast.success('Pedidos atualizados com sucesso');
        commit('toggleLoading', false);
        return dispatch('getOrdersToChangeStatus', { filters });
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  getShipperEvents({ commit }) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
      query {
        shipperEvents {
          micro {
            id
            code
            description
          }
          macro {
            id
            code
            description
          }
          base {
            id
            code
            description
          }
          source_id
        }
      }`)
      .then((res) => {
        const {
          data = {},
        } = res || {};

        const {
          shipperEvents = [],
        } = data || {};

        const filteredShipperEvents = shipperEvents.filter((shipperEvent) => {
          const {
            source_id,
          } = shipperEvent;
          return source_id === 3;
        });
        commit('toggleLoading', false);
        commit('setShipperEvents', filteredShipperEvents);

        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);

        return Promise.reject(err);
      });
  },
  addEvents({ commit }, form) {
    commit('toggleLoading', true);

    return GraphQlClient.mutation(`
      mutation(
        $order_number_list: [String]!
        $events: [EventInput]!
      ) {
        addEventsLote(
          order_number_list: $order_number_list
          events: $events
        ) {
            ok
          }
        }
      `, form)
      .then((res) => {
        const {
          data,
        } = res;

        const {
          addEventsLote,
        } = data;

        const {
          ok,
        } = addEventsLote;

        commit('toggleLoading', false);
        ScToast.success(ok);
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  getFiles({ commit, state }, fileType) {
    commit('toggleLoading', true);
    const {
      currentPage = 1,
      perPage = 10,
    } = state;

    const params = {
      file_type: fileType,
      current_page: currentPage,
      per_page: perPage,
    };

    return GraphQlClient.query(`
      query (
        $file_type: String,
        $current_page: Int,
        $per_page: Int
      ) {
        files (
          file_type: $file_type,
          current_page: $current_page,
          per_page: $per_page,
        ) {
          items {
            file_name,
            process_date,
            process_status,
            download_url,
            upload_date,
          }
          total
        }
      }
    `, params)
      .then(({ data = {} }) => {
        const {
          files,
        } = data || {};

        const {
          items = [],
          total = 0,
        } = files || {};

        commit('setFiles', items);
        commit('setFilesCount', total);
        commit('toggleLoading', false);

        return Promise.resolve(data);
      })
      .catch((err) => {
        commit('toggleLoading', false);

        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-order/features/change-order/store/actions.js